import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ServiceBase } from '../../core/services/service.base';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class Agrodrive extends ServiceBase {
  constructor(public http: HttpClient) {
    super();
  }

  getAgrodrive(): Observable<any> {
    return this.http
      .get(this.UrlServiceV1 + 'fetch-agrodrive', {
        ...this.obterAuthHeader(),
      })
      .pipe(map(this.extractData), catchError(this.serviceError));
  }

  uploadFiles(formData: FormData): Observable<any> {
    return this.http
      .post(this.UrlServiceV1 + 'upload-agrodrive-files', formData, {
        ...this.obterAuthHeaderForFileUpload(),
      })
      .pipe(map(this.extractData), catchError(this.serviceError));
  }

  getDownloadUrl(
    deviceId: string,
    category: string,
    fileName: string,
  ): Observable<{ url: string }> {
    const params = `deviceId=${encodeURIComponent(deviceId)}&category=${encodeURIComponent(category)}&fileName=${encodeURIComponent(fileName)}`;
    return this.http
      .get<{ url: string }>(
        this.UrlServiceV1 + `get-agrodrive-download-url?${params}`,
        {
          ...this.obterAuthHeader(),
        },
      )
      .pipe(map(this.extractData), catchError(this.serviceError));
  }

  moveFiles(moveRequest: {
    sourceDeviceId: string;
    targetDeviceIds: string[];
    category: 'guides' | 'boundaries' | 'variableRateMaps';
    fileName: string;
  }): Observable<any> {
    return this.http
      .post(this.UrlServiceV1 + 'move-agrodrive-files', moveRequest, {
        ...this.obterAuthHeader(),
      })
      .pipe(map(this.extractData), catchError(this.serviceError));
  }
}
